
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/section/crash-course/[slug]",
      function () {
        return require("private-next-pages/section/crash-course/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/section/crash-course/[slug]"])
      });
    }
  